<template>
  <div>
    <div v-if="utype != 1">
      <div class="cont" v-if="xsShow">
        <div class="typeList">
          <div
            class="type dis-cent"
            :class="index == typeOn ? 'on' : ''"
            v-for="(item, index) in typeList"
            @click="typeClick(index)"
          >
            <div class="name">{{ item }}</div>
            <div class="hen" v-if="index == typeOn"></div>
          </div>
        </div>
        <template v-if="typeOn == 0">
          <div class="box">
            <div class="inpBox">
              <input
                type="text"
                v-model="mobile"
                placeholder="请输入手机号码"
              />
            </div>
            <div class="inpBox">
              <input
                type="text"
                v-model="yanzheng"
                placeholder="请输入验证码"
              />
              <div class="yzmBox dis-cent" v-if="!yzmShow" @click="yzmClick">
                获取验证码
              </div>
              <div class="yzmBox dis-cent" v-if="yzmShow">{{ time }}</div>
            </div>
          </div>
          <div class="anBtn dis-cent" @click="dxClick">登录</div>
        </template>
        <template v-if="typeOn == 1">
          <div class="box">
            <div class="inpBox">
              <input
                type="text"
                v-model="mobile"
                placeholder="请输入手机号码"
              />
            </div>
            <div class="inpBox">
              <input
                type="password"
                v-model="password"
                placeholder="请输入密码"
              />
            </div>
          </div>
          <div class="anBtn dis-cent" @click="saveClick">登录</div>
        </template>
        <div class="txtBox" @click="tyClick">
          <div class="kuang dis-cent" :class="tyShow ? 'on' : ''">
            <div class="iconfont icon-right" v-if="tyShow"></div>
          </div>
          <div class="txt">
            同意<span>《用户服务协议》</span>及<span>《个人信息保护政策》</span>
          </div>
        </div>
      </div>
      <div class="dlCont" v-if="!xsShow">
        <div class="box">
          <div class="img">
            <img
              :src="
                info.memberinfo.avatars
                  ? $imgUrl + info.memberinfo.avatars
                  : 'https://www.yhrl.com/static/avatar/man.png'
              "
              alt=""
            />
          </div>
          <div class="contBox">
            <div class="name">{{ info.memberinfo.realname }}</div>
            <div class="texts">
              <div class="txt" v-if="age != 2024">{{ age }}岁</div>
              <div class="txt" v-if="age == 2024">未填写</div>
              <div class="shu"></div>
              <div class="txt">
                {{
                  info.memberinfo.education_cn
                    ? info.memberinfo.education_cn
                    : "未填写"
                }}
              </div>
              <div class="shu"></div>
              <div class="txt">
                {{
                  info.memberinfo.experience_cn
                    ? info.memberinfo.experience_cn
                    : "未填写"
                }}
              </div>
            </div>
          </div>
        </div>
        <div class="zxBox">
          <div class="name">当前状态:</div>
          <a-dropdown>
            <div class="selectBox dis-cent">
              <div class="text c-1">{{ currentTxt }}</div>
              <div class="iconfont icon-unfold"></div>
            </div>
            <a-menu
              slot="overlay"
              @click="hyClick"
              :selectedKeys="[typeData['目前状态']]"
            >
              <a-menu-item
                :key="'目前状态_' + item.id + '_' + item.c_name"
                v-for="item in current"
                >{{ item.c_name }}</a-menu-item
              >
            </a-menu>
          </a-dropdown>
        </div>
      </div>
    </div>
    <div class="xcxBox">
      <div class="box">
        <div class="title">找工作上玉环人力网</div>
        <div class="text">微信扫码进入小程序</div>
        <div class="text">随时随地关注岗位</div>
      </div>
      <div class="img">
        <img src="../../assets/img/xcx.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { Menu, Form, Input, Dropdown, Upload, Icon } from "ant-design-vue";
export default {
  components: {
    "a-menu": Menu,
    "a-menu-item": Menu.Item,
    "a-sub-menu": Menu.SubMenu,
    "a-form": Form,
    "a-form-item": Form.Item,
    "a-input": Input,
    "a-dropdown": Dropdown,
    "a-textarea": Input.TextArea,
    "a-upload": Upload,
    "a-icon": Icon,
  },
  name: "",
  data() {
    return {
      typeOn: 0,
      typeList: ["登录/注册", "密码登录"],
      zhShow: false,
      mobile: "",
      password: "",
      time: 60,
      yzmShow: false,
      yanzheng: "",
      tyShow: false,
      info: {
        memberinfo: {},
      },
      age: 0,
      xsShow: false,
      currentTxt: "请选择当前状态",
      currentId: "",
      current: [],
      typeData: {
        目前状态: "",
      },
      utype: "",
    };
  },
  created() {
    this.utype = window.localStorage.getItem("utype");
    let category_gets = window.localStorage.getItem("category_gets");
    if (category_gets) {
      this.category_gets = JSON.parse(category_gets);
      this.typeHcGet(this.category_gets);
    } else {
      this.typeGet();
    }
    this.getlog();
  },
  methods: {
    typeGet() {
      this.$get("/common/category_gets", {
        pageNo: -1,
      }).then((res) => {
        window.localStorage.setItem("category_gets", JSON.stringify(res.data));
        this.typeHcGet(res.data);
      });
    },
    typeHcGet(data) {
      // 所属行业
      let current = [];
      for (let i = 0; i < data.length; i++) {
        const e = data[i];
        e.select = false;
        if (e.c_alias == "QS_current") {
          current.push(e);
        }
      }
      this.current = current;
    },
    hyClick(e) {
      let key = e.key.split("_");
      let data = {
        type: key[0],
        id: key[1],
        name: key[2],
      };
      this.typeData[key[0]] = e.key;
      if (key[0] == "目前状态") {
        this.currentTxt = data.name;
        this.currentId = data.id;
        this.$post("/nozzle/web/member_current", {
          current: this.currentId,
          current_cn: this.currentTxt,
        }).then((res) => {});
      }
    },
    getlog() {
      this.$get("/nozzle/web/check_login_status").then((res) => {
        console.log(res);
        if (res.status) {
          this.xsShow = false;
          this.get();
        } else {
          this.xsShow = true;
        }
      });
    },
    get() {
      this.$get("/nozzle/web/member_info").then((res) => {
        this.info = res;
        const currentYear = new Date().getFullYear();
        this.age = currentYear - Number(res.memberinfo.birthday);
        this.currentTxt = res.memberinfo.current_cn
          ? res.memberinfo.current_cn
          : "请选择当前状态";
        this.currentId = res.memberinfo.current;
      });
    },
    tyClick() {
      this.tyShow = !this.tyShow;
    },
    yzmClick() {
      if (!this.mobile) {
        this.$message.error("请先输入手机号");
        return;
      }
      this.yzmShow = true;
      this.timeYs = setInterval(() => {
        if (this.time == 0) {
          this.yzmShow = false;
          this.time = 60;
          clearInterval(this.timeYs);
        } else {
          this.time--;
        }
      }, 1000);
      this.$post("/common/sms_send", {
        mobile: this.mobile,
      }).then((res) => {
        console.log(res);
        if (res.data.status == 1) {
          this.$message.success("发送成功");
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    typeClick(i) {
      this.typeOn = i;
    },
    dxClick() {
      if (!this.tyShow) {
        this.$message.error("请先同意《用户服务协议》及《个人信息保护政策》");
        return;
      }
      if (!this.mobile) {
        this.$message.error("请输入手机账号");
        return;
      }
      if (!this.yanzheng) {
        this.$message.error("请输入验证码");
        return;
      }
      this.$post("/nozzle/web/login_sms", {
        mobile: this.mobile,
        code: this.yanzheng,
      }).then((res) => {
        console.log(res);
        if (res.data.status == 1) {
          if (this.zhShow) {
            window.localStorage.setItem("chuantianmobile", this.mobile);
          }
          window.localStorage.setItem("rlToken", res.data.data);
          window.localStorage.setItem(
            "member",
            JSON.stringify(res.data.member)
          );
          this.$message.success("登录成功");
          window.localStorage.setItem("utype", res.data.member.utype);
          if (res.data.member.utype == 1) {
            this.$router.replace({
              path: "/gongsi/tjrcIndex",
              query: {},
            });
          }
          if (res.data.member.utype == 2) {
            this.$router.replace({
              path: "/index",
              query: {},
            });
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    saveClick() {
      if (!this.tyShow) {
        this.$message.error("请先同意《用户服务协议》及《个人信息保护政策》");
        return;
      }
      if (!this.mobile) {
        this.$message.error("请输入手机账号");
        return;
      }
      if (!this.password) {
        this.$message.error("请输入密码");
        return;
      }
      this.$post("/nozzle/web/login", {
        account: this.mobile,
        password: this.password,
      }).then((res) => {
        console.log(res.data);
        if (res.data.status == 1) {
          window.localStorage.setItem("rlToken", res.data.data);
          window.localStorage.setItem(
            "member",
            JSON.stringify(res.data.member)
          );
          this.$message.success("登录成功");
          window.localStorage.setItem("utype", res.data.member.utype);
          if (res.data.member.utype == 1) {
            this.$router.replace({
              path: "/gongsi/tjrcIndex",
              query: {},
            });
          }
          if (res.data.member.utype == 2) {
            location.reload();
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.cont {
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;

  .typeList {
    display: flex;
    align-items: center;
    color: #666;
    cursor: pointer;

    .type {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .hen {
        height: 2px;
        width: 65px;
        background-color: #1a78ec;
      }
    }

    .on {
      color: #000;
      font-size: 16px;
    }
  }

  .box {
    padding-top: 25px;

    .inpBox {
      height: 45px;
      border-radius: 45px;
      background-color: rgb(246, 246, 248);
      margin-bottom: 20px;
      overflow: hidden;
      position: relative;

      input {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding-left: 20px;
      }

      .yzmBox {
        position: absolute;
        top: 12px;
        right: 0;
        width: 100px;
        height: 21px;
        font-size: 12px;
        cursor: pointer;
        color: #1a78ec;
        border-left: 1px solid #ebebeb;
        box-sizing: border-box;
      }
    }
  }

  .anBtn {
    background-color: #1a78ec;
    color: #fff;
    height: 45px;
    border-radius: 45px;
    cursor: pointer;
  }

  .txtBox {
    display: flex;
    align-items: center;
    margin-top: 15px;
    font-size: 12px;
    cursor: pointer;

    .kuang {
      width: 16px;
      height: 16px;
      border-radius: 5px;
      border: 1px solid #ebebeb;
      margin-right: 5px;

      .iconfont {
        font-size: 12px;
      }
    }

    .on {
      border: 1px solid #1a78ec;
      color: #fff;
      background-color: #1a78ec;
    }

    .txt {
      span {
        color: #1a78ec;
      }
    }
  }

  .txtBox:hover {
    .kuang {
      animation: 0.5s both yansebianhua;
    }

    @keyframes yansebianhua {
      0% {
        border: 1px solid #ebebeb;
      }

      100% {
        border: 1px solid #1a78ec;
      }
    }
  }
}

.xcxBox {
  padding: 15px;
  background: linear-gradient(to right, #2f85ee, #1a78ec);
  margin-top: 15px;
  border-radius: 10px;
  display: flex;
  margin-bottom: 15px;

  .box {
    width: calc(100% - 120px);
    color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 15px;
    box-sizing: border-box;

    .title {
      font-size: 19px;
      font-weight: 500;
      margin-bottom: 10px;
    }

    .text {
      opacity: 0.9;
    }
  }

  .img {
    width: 120px;
    height: 120px;
    border-radius: 10px;
    overflow: hidden;
  }
}

.dlCont {
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;
  overflow: hidden;

  .box {
    display: flex;

    .img {
      height: 70px;
      width: 70px;
      border-radius: 50%;
    }

    .contBox {
      padding-left: 10px;
      width: calc(100% - 70px);
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .name {
        font-weight: 600;
        font-size: 18px;
        margin-bottom: 2px;
      }

      .texts {
        display: flex;
        align-items: center;
        margin-top: 7px;

        .shu {
          width: 1px;
          height: 13px;
          background-color: #e4e4e4;
          margin: 0 10px;
        }
      }
    }
  }

  .zxBox {
    overflow: hidden;
    display: flex;
    align-items: center;

    .name {
      font-size: 14px;
      margin-top: 10px;
      width: 75px;
    }
  }

  .selectBox {
    margin-top: 10px;
    // width: 140px;
    float: left;
    border: 1px solid #cacaca;
    height: 35px;
    padding: 0 10px;
    border-radius: 5px;
    font-size: 14px;
    cursor: pointer;
    display: flex;
    align-items: center;
    font-weight: 500;
    color: #000;
    box-sizing: border-box;
    width: calc(100% - 75px);

    .text {
      max-width: calc(100% - 25px);
    }

    .iconfont {
      font-size: 14px;
      position: relative;
      top: 1px;
      left: 2px;
      margin-left: 5px;
    }
  }

  .selectBox:hover {
    animation: 0.5s both yansebianhua;
  }

  @keyframes yansebianhua {
    0% {
      border: 1px solid #cacaca;
    }

    100% {
      border: 1px solid #1a78ec;
      color: #147ee0;
    }
  }
}
</style>
